export enum SatelliteOrbitEnum {
  Sentinel1AAscending = 'sentinel-1a-ascending',
  Sentinel1ADescending = 'sentinel-1a-descending',
  Sentinel1BAscending = 'sentinel-1b-ascending',
  Sentinel2A = 'sentinel-2a',
  Sentinel2B = 'sentinel-2b',
  Landsat8 = 'landsat-8',
}

export namespace SatelliteOrbitEnum {
  export const LABELS: Record<SatelliteOrbitEnum, string> = {
    [SatelliteOrbitEnum.Sentinel1AAscending]: 'Sentinel-1A Ascendente',
    [SatelliteOrbitEnum.Sentinel1ADescending]: 'Sentinel-1A Descendente',
    [SatelliteOrbitEnum.Sentinel1BAscending]: 'Sentinel-1B Ascendente',
    [SatelliteOrbitEnum.Sentinel2A]: 'Sentinel-2A',
    [SatelliteOrbitEnum.Sentinel2B]: 'Sentinel-2B',
    [SatelliteOrbitEnum.Landsat8]: 'Landsat 8',
  };
}
